import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import * as Icon from "react-feather";
import { Box, Modal, Typography } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function Footer() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    msg_subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const onButtonClick = () => {
    const pdfUrl = "/img/Running-List.pdf";
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Running-List.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    const fileTitle = "Running-List.pdf";
    const dataToSend = { ...formData, file_title: fileTitle }; // Adding the file title

    try {
      const response = await axios.post(
        "https://api.vsktextiles.com/api/send-email",
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Handle response
      if (response.status !== 200) {
        console.error("Error Response:", response.data);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Show success message using Snackbar
      openSnackbar("Message sent successfully!", "success");

      setFormData({
        name: "",
        email: "",
        phone_number: "",
        msg_subject: "",
        message: "",
      });

      handleClose();
      onButtonClick();
    } catch (error) {
      console.error("Error:", error);
      openSnackbar(
        error.message || "An error occurred while sending your message.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <footer className="footer-area bg-f7fafd">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget">
                <div className="logo">
                  <Link to="/Home">
                    <img src="/img/vsk-logo.png" alt="logo" />
                  </Link>
                  <br />
                  <br />
                  <ul className="list">
                    <li>
                      <Link to="/Fabrics">Fabrics</Link>
                    </li>
                    <li style={{ cursor: "pointer" }} onClick={handleOpen}>
                      Download our Running List
                    </li>
                    <button style={{ cursor: "pointer" }} onClick={handleOpen}>
                      <img
                        style={{ width: "50px" }}
                        src="/img/PDF-link.png"
                        alt="Download PDF"
                      />
                    </button>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget pl-5">
                <h3>Company</h3>
                <ul className="list">
                  <li>
                    <Link to="/VSKAbout">About Us</Link>
                  </li>
                  <br />
                  <li>
                    <Link to="/VSKQuality">Quality</Link>
                  </li>
                  <br />
                  <li>
                    <Link to="/Contact">Contact</Link>
                  </li>
                </ul>
                <div className="certification-logos">
                  <img
                    src="/img/GOTS.jpeg"
                    alt="GOTS"
                    title="Global Organic Textile Standard"
                  />
                  <img
                    src="/img/GRS.jpeg"
                    alt="GRS"
                    title="Global Recycled Standard"
                  />
                  <img
                    src="/img/Organic 100 Content Standard.png"
                    alt="Organic 100"
                    title="Organic 100 Content Standard"
                  />
                  <img
                    src="/img/BCI.jpeg"
                    alt="BCI"
                    title="Better Cotton Initiative"
                  />
                  <img
                    src="/img/fairtrade.jpeg"
                    alt="Fairtrade"
                    title="Fairtrade International"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget">
                <h3>Address</h3>
                <ul className="footer-contact-info">
                  <li>
                    <Icon.MapPin />• Registered Office: Chennai, India.<br/>•
                    Factory Address: Kovilpatti, Tuticorin, Tamil Nadu, India.<br/>•
                    Marketing Office: Coimbatore, Tamil Nadu, India.<br/>
                  </li>
                  <li>
                    <Icon.Mail /> Email:{" "}
                    <a href="mailto:info@vsktextiles.com">
                      info@vsktextiles.com
                    </a>
                  </li>
                  <li>
                    <Icon.PhoneCall /> Phone:{" "}
                    <a href="tel:+91 9941620909">+91 9941620909</a>
                  </li>
                </ul>
                <ul className="social-links">
                  <li>
                    <a
                      href="https://www.linkedin.com/company/vsk-textiles-private-limited"
                      className="linkedin"
                    >
                      <Icon.Linkedin />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-12 col-md-12">
              <div className="copyright-area">
                <p>
                  Copyright @{new Date().getFullYear()} VSK Textiles. All rights
                  reserved
                </p>
              </div>
            </div>
          </div>
        </div>
        <img src="/img/map.png" className="map" alt="map" />
        <div className="shape1">
          <img src="/img/shape1.png" alt="shape" />
        </div>
        <div className="shape8 rotateme">
          <img src="/img/shape2.svg" alt="shape" />
        </div>
      </footer>

      <Modal
        keepMounted
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Download Running List
          </Typography>
          <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Please fill out the form below to receive our Running List.
          </Typography>
          <section className="contact-area ptb-80">
            <div className="container">
              <div className="row h-100 justify-content-center align-items-center">
                <div className="col-lg-12 col-md-12">
                  <form id="contactForm" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="form-control"
                            required
                            placeholder="Name"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-control"
                            required
                            placeholder="Email"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-6">
                        <div className="form-group">
                          <input
                            type="number"
                            maxLength={10}
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                            required
                            className="form-control"
                            placeholder="Phone"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="msg_subject"
                            value={formData.msg_subject}
                            onChange={handleChange}
                            required
                            className="form-control"
                            placeholder="Subject"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            className="form-control"
                            required
                            placeholder="Your Message"
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <button
                          type="submit"
                          className="btn btn-primary clearfix"
                          disabled={loading}
                        >
                          {loading ? "Sending..." : "Send Message & Download"}
                        </button>
                        {errorMessage && (
                          <div className="alert alert-danger">
                            {errorMessage}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </Box>
      </Modal>

      {/* Snackbar for notifications */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Positioning the Snackbar
        style={{ justifyContent: "center" }}
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%", right: 0 }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
